module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.1-98.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.2.1.md
// module id = 515
// module chunks = 328